import {
  AuthCenteredLayout,
  ResetLinkMissing,
  ResetPasswordForm,
  useResetPasswordScreen,
} from '@/features/auth';
import Notice from '@/shared/ui/Notice';

export default function ResetPasswordPage() {
  const screen = useResetPasswordScreen();

  let content;
  if (!screen.hasToken) content = <ResetLinkMissing />;
  else if (screen.done) {
    content = (
      <Notice tone="success" focusOnMount className="mt-6">
        Password reimpostata. Puoi accedere con le nuove credenziali.
      </Notice>
    );
  } else {
    content = (
      <>
        {screen.error && (
          <Notice tone="danger" className="mt-6">
            {screen.error}
          </Notice>
        )}
        <ResetPasswordForm submitting={screen.submitting} onSubmit={screen.submit} />
      </>
    );
  }

  return (
    <AuthCenteredLayout
      title="Nuova password"
      description="Scegli una password sicura per il tuo account."
    >
      {content}
    </AuthCenteredLayout>
  );
}
